module.exports = __webpack_public_path__ + "media/images/Octopus-960ab2d2.webp";